export const environment = {
  production: true,
  verboseRoutes: false,
  apiBase: 'https://api.learnerverified.com/',
  appBase: 'https://app.learnerverified.com/',
  wss: 'wss://api.learnerverified.com/cable',
  cdn: 'app.learnerverified.com',
  octoproctorUrl: 'https://wkt.ca.proctoring.app'
};
